// Minecraft block types and pricing
export const MINECRAFT_BLOCK_TYPES = [
  { id: "1x1", name: "Block", width: 1, height: 1, description: "Standard block", isCommon: true },
  { id: "1x2", name: "2 Blocks", width: 1, height: 2, description: "2 stacked blocks", isCommon: true },
  { id: "2x2", name: "2x2 Blocks", width: 2, height: 2, description: "2x2 block area", isCommon: true },
  { id: "2x4", name: "2x4 Blocks", width: 2, height: 4, description: "2x4 block area", isCommon: true },
];

// Minecraft block pricing (estimated per block)
export const minecraftBlockPrices: { [key: number]: number } = {
  0: 0.05, // White (Quartz)
  1: 0.04, // Dark Stone Gray (Stone)
  2: 0.06, // Bright Red (Red Concrete)
  3: 0.05, // Dark Green (Green Concrete)
  4: 0.06, // Earth Blue (Blue Concrete)
  5: 0.05, // Bright Yellow (Yellow Concrete)
  6: 0.06, // Orange (Orange Concrete)
  7: 0.07, // Medium Lavender (Purple Concrete)
  8: 0.05, // Reddish Brown (Brown Concrete)
  9: 0.04, // Light Stone Gray (Light Gray Concrete)
  10: 0.04, // Medium Stone Gray (Gray Concrete)
  11: 0.06, // Cool Yellow (Cyan Concrete)
  12: 0.05, // Silver (Iron Block)
  13: 0.06, // Orange (Orange Concrete)
  14: 0.06, // Sand Blue (Light Blue Concrete)
  15: 0.05, // Sand Yellow (Yellow Concrete)
  16: 0.07, // Medium Azur (Magenta Concrete)
  17: 0.05, // Bright Green (Lime Concrete)
  18: 0.05, // Bright Yellowish Green (Lime Concrete)
  19: 0.06, // Earth Green (Green Concrete)
  20: 0.05, // Nougat (Terracotta)
};

// Minecraft block type multipliers (blocks are simpler than LEGO)
export const minecraftBlockMultipliers: { [key: string]: number } = {
  "1x1": 1.0,
  "1x2": 2.0,
  "2x2": 4.0,
  "2x4": 8.0,
  "1x3": 3.0,
  "1x4": 4.0,
  "2x3": 6.0,
  "2x6": 12.0,
  "2x8": 16.0,
  "4x4": 16.0,
  "4x6": 24.0,
  "4x8": 32.0,
};

export const getMinecraftBlockName = (colorName: string): string => {
  const blockNames: { [key: string]: string } = {
    White: "White Concrete",
    "Dark Stone Gray": "Stone",
    "Bright Red": "Red Concrete",
    "Dark Green": "Green Concrete",
    "Earth Blue": "Blue Concrete",
    "Bright Yellow": "Yellow Concrete",
    "Flame Orangey Yellow": "Orange Concrete",
    "Medium Lavender": "Purple Concrete",
    "Reddish Brown": "Brown Concrete",
    "Light Stone Gray": "Light Gray Concrete",
    "Medium Stone Gray": "Gray Concrete",
    "Cool Yellow": "Cyan Concrete",
    Silver: "Iron Block",
    Orange: "Orange Concrete",
    "Sand Blue": "Light Blue Concrete",
    "Sand Yellow": "Yellow Concrete",
    "Medium Azur": "Magenta Concrete",
    "Bright Green": "Lime Concrete",
    "Bright Yellowish Green": "Lime Concrete",
    "Earth Green": "Green Concrete",
    Nougat: "Terracotta",
  };
  return blockNames[colorName] || "Concrete";
};
